import React from 'react'
import { observer } from 'mobx-react-lite'

import { useMessages } from '../../../hooks/snackbarHooks'
import { useApi, useStore } from '../../../hooks/storeHook'
import { useOzonAccountOptional } from '../../../hooks/routeHooks'

import { OzonApiSettings } from './OzonApiSettings'
import { OzonStoresForm } from '../../OzonStoresForm'
import { StoreSettingsPage } from '../StoreSettingsPage'
import { OzonOrdersSettings } from './OzonOrdersSettings'
import { OzonPricesSettings } from './OzonPricesSettings'
import { OzonReturnsSettings } from './OzonReturnsSettings'
import { CommissionsSettings } from '../CommissionsSettings'
import { OzonSuppliesSettings } from './OzonSuppliesSettings'

import { IntegrationType } from '../../../server/mpsklad_core/Entity/IntegrationType'
import { OzonDeliveryType } from '../../../server/mpsklad_core/Entity/Ozon/OzonDeliveryType'
import { EditStoreAccountMsDataModel } from '../../../server/mpsklad_core/Models/EditStoreAccountMsDataModel'

export const OzonSettingsPage =
  observer(() => {
    const api = useApi()
    const store = useStore()
    const {showSuccess} = useMessages()

    const account = useOzonAccountOptional()

    const onSubmitMsData =
      async (msData: EditStoreAccountMsDataModel) => {
        try {
          const editedAccount = await api.userSync.editOzonMsData(msData)
          store.syncStore.replaceStoreAccount(editedAccount)
          showSuccess('Сохранено!')
        } catch (e) {
          console.error('Failed to edit Ozon MS data', e)
        }
      }

    return (
      <StoreSettingsPage
        key={account?.id ?? 0}
        account={account}
        integrationType={IntegrationType.Ozon}
        allowSuppliesSettings={account?.deliveryType === OzonDeliveryType.FBO}
        onSubmitMsData={onSubmitMsData}
        ApiSettingsComponent={OzonApiSettings}
        OrdersSettingsComponent={OzonOrdersSettings}
        WarehousesSettingsComponent={OzonStoresForm}
        ReturnsSettingsComponent={OzonReturnsSettings}
        CommissionsSettingsComponent={CommissionsSettings}
        PricesSettingsComponent={OzonPricesSettings}
        SuppliesSettingsComponent={OzonSuppliesSettings}
      />
    )
  })